import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface GeneratePartnerParams {
  trailerMovementId: number;
  shipmentNumber: string;
  book: number;
  soft: number;
  misc: number;
  furn: number;
  oli: number;
  isInboundTransfer: boolean;
  isOutboundTransfer: boolean;
  isGeneratePayment: boolean;
  customerKey: number;
}

export const generatePartnerApi = (data: GeneratePartnerParams) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SAVERS}/GenerateTransfer`,
  });
};

export type GeneratePartnerResponse = {}[];

export const createPartner = async (params: GeneratePartnerParams): Promise<GeneratePartnerResponse> => {
  const response: AxiosResponse<GeneratePartnerResponse> = await generatePartnerApi(params);
  return response.data;
};
